/* eslint-disable */

/* Generated by Coupe SDK v2.x */
/* DO NOT MODIFY THIS FILE */

/* Schema Info: */
/* act3 common 配置 */
/*  */

import { CoupeSDK } from "@hll/coupe-sdk";
import { defineProp, fieldGetter } from "@hll/coupe-sdk/dist/cli/genCode";

export class CoupeDataModel {
  constructor(raw) {
    defineProp(this, "isUseNewWay", fieldGetter(raw["isUseNewWay"], undefined));

    defineProp(
      this,
      "disableHomeAd",
      fieldGetter(raw["disableHomeAd"], undefined)
    );

    defineProp(
      this,
      "withdrawToWalletNote",
      fieldGetter(raw["withdrawToWalletNote"], undefined)
    );

    defineProp(
      this,
      "disableEncrypt",
      fieldGetter(raw["disableEncrypt"], undefined)
    );
  }

  /**
   * 地理位置授权安全整改开关
   *
   * @type {?boolean} isUseNewWay
   */
  isUseNewWay;

  /**
   * App 内跳转首页车型时是否禁止首页弹窗
   * https://huolala.feishu.cn/wiki/DjEwwgBWliqZJFkvDAJcq8KHnSh
   * @type {?boolean} disableHomeAd
   */
  disableHomeAd;

  /**
   * 提现到余额提示文案
   * 红包奖励提现到余额的提示文案
   * @type {?string} withdrawToWalletNote
   */
  withdrawToWalletNote;

  /**
   * 敏感信息加密传输降级
   * 默认关闭，打开表示降级为不加密
   * @type {?boolean} disableEncrypt
   */
  disableEncrypt;
}

/** @type CoupeSDK<CoupeDataModel> */
const sdk = new CoupeSDK({ coupeId: "f30a3a2e86914e35a4b6ecb38a73d3d4" });
sdk.onAfterDataHook((data) => new CoupeDataModel(data));

export default sdk;
